import React, { forwardRef, useMemo, useRef, useState } from "react";
import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import "react-quill/dist/quill.snow.css";
import ReactQuill from "react-quill";
import { ImageBlockUploader } from "./ImageBlockUploader";
import CustomModal from "../../../common/customModal/CustomModal";

const TOOLBAR = [
  [{ header: [2, 3, 4, false] }],
  ["bold", "italic", "underline", "strike"],
  ["blockquote", "code-block"],
  [{ list: "ordered" }, { list: "bullet" }],
  ["link", "image"],
  ["clean"],
];

export const RichTextEditor = forwardRef(function RichTextEditor(
  { value, onChange, readOnly = false, placeholder = "Start writing…" },
  ref
) {
  const quillRef = useRef(null);
  const [imgDialogOpen, setImgDialogOpen] = useState(false);

  // stable ref so modules object identity never changes between renders
  const openImgDialog = useRef(() => setImgDialogOpen(true));

  const modules = useMemo(() => ({
    toolbar: {
      container: TOOLBAR,
      handlers: { image: () => openImgDialog.current() },
    },
  }), []);

  const handleImageUpload = (url) => {
    const editor = quillRef.current?.getEditor();
    if (editor && url) {
      const range = editor.getSelection(true);
      editor.insertEmbed(range.index, "image", url);
    }
    setImgDialogOpen(false);
  };

  React.useImperativeHandle(ref, () => ({
    getEditor: () => quillRef.current?.getEditor(),
  }));

  return (
    <Box sx={{ "& .ql-container": { minHeight: 400, fontFamily: "Heebo" }, "& .ql-editor": { minHeight: 400 } }}>
      <ReactQuill
        ref={quillRef}
        theme="snow"
        value={value || ""}
        onChange={onChange}
        readOnly={readOnly}
        placeholder={placeholder}
        modules={modules}
      />

      <CustomModal open={imgDialogOpen} onClose={() => setImgDialogOpen(false)}>
        <Box sx={{ p: 1 }}>
          <ImageBlockUploader
            label="Upload & Insert"
            onUpload={(url) => handleImageUpload(url)}
          />
        </Box>
      </CustomModal>
    </Box>
  );
});
